<template>
  <div>
    <!-- <HeaderSecondary /> -->
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    
    <div class="max-w-7xl bg-white pt-16 pb-20 mx-auto px-4 sm:px-6 lg:px-8 lg:pt-24 lg:pb-28">

      
      <!-- <div v-if="error" class="text-red-500 bg-red-100 py-5 text-center rounded-lg font-bold">{{error}}</div> -->
      <ErrorMessage v-if="error" :error="error" class="mt-2" />

      <Loader v-if="loading" />
      <div v-else class="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">

        <button v-if="user && user.is_cm" class="py-3 px-6 text-white rounded-lg bg-green-400 shadow-lg block md:inline-block">
          <router-link :to="{ name: 'article_edit', params: { id: -1 } }">Новая статья</router-link>
        </button>

        <div class="mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12">

          <div v-for="article in data" v-bind:key="article.id">
            <p class="text-sm text-gray-500">
              <!-- <time datetime="2020-03-16">{{myDate(article.adate)}}</time> -->
              <time>{{myDate(article.adate)}}</time>
            </p>
            <div v-if="user && (user.is_cm == 1)" class="mt-3">
              <router-link
                :to="{ name: 'article_edit', params: { id: article.id } }"
                class="text-base font-semibold text-indigo-600 hover:text-indigo-500"
                >Редактировать</router-link
              >
            </div>
            <div v-if="user && (user.is_cm == 1)">
              <form @submit.prevent="deleteRecord(article.id)">
                <button type="submit" class="text-red-600 hover:text-red-900">Удалить</button>
              </form>
            </div>
            <router-link
              :to="{ name: 'article_show', params: { id: article.id } }"
              class="mt-2 block"
            >
              <p class="text-xl font-semibold text-gray-900">
                {{ article.name }}
              </p>
              <p class="mt-3 text-base text-gray-500" v-html="article.description">
              </p>
            </router-link>

            <div>
              <router-link
                :to="{ name: 'article_show', params: { id: article.id } }"
                class="text-base font-semibold text-indigo-600 hover:text-indigo-500"
                >Читать далее</router-link
              >
            </div>
          </div>


        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import axios from "axios";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import moment from "moment";
import Loader from "@/components/Loader";
import ErrorMessage from "../components/ErrorMessage";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      title: "Статьи",
      bcrumbs: [],
      data: null,
      error: '',
      loading: true,
    };
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  methods: {
    myDate(d) {
      return moment(d).format(
          "DD.MM.YYYY"
        );
    },
    
    async loadData() {
      this.error = "";
      try {
        this.loading = true;
        let response = await axios.get("articles");
        this.data = response.data.articles;
        this.loading = false;
      } catch (e) {
        this.error = "Ошибка при загрузке данных";
      }
    },


    async deleteRecord(id) {
      this.error = "";
      try {
        let response = await axios.delete("articles/" + id);
        if (response.status == 200) {
          // удаление эл-та из списка "на клиенте":
          let index = this.data.findIndex((tmpdata) => tmpdata.id == id);
          this.data.splice(index, 1);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.error = e.response.data.error;
        } else {
          this.error = "Неизвестная ошибка при удалении.";
        }
      }
    },



  },
  components: {
    PageTitle,
    BreadCrumbs,
    Loader,
    ErrorMessage,
  },
};
</script>